import React, { useEffect, useRef, useState } from 'react';
import { HERO_POSTER, HERO_VIDEO } from '../constants/images';

function HeroVideo() {
  const videoRef = useRef(null);
  const [posterReady, setPosterReady] = useState(false);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = HERO_POSTER;
    img.onload = () => setPosterReady(true);
  }, []);

  useEffect(() => {
    if (!posterReady || !videoRef.current) return;
    videoRef.current.load();
  }, [posterReady]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const tryPlay = () => {
      video.play().catch(() => {});
    };

    if (video.readyState >= 3) {
      setVideoReady(true);
      tryPlay();
    }

    video.addEventListener('canplay', tryPlay);
    return () => video.removeEventListener('canplay', tryPlay);
  }, [posterReady]);

  const handleVideoReady = () => {
    setVideoReady(true);
  };

  const isLoaded = posterReady || videoReady;

  return (
    <div className={`hero-media-wrapper ${isLoaded ? 'loaded' : ''}`}>
      <img
        src={HERO_POSTER}
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        decoding="async"
        className={`hero-poster ${videoReady ? 'hero-poster-hidden' : ''}`}
      />
      <video
        ref={videoRef}
        className={`hero-video ${videoReady ? 'hero-video-visible' : ''}`}
        src={HERO_VIDEO}
        poster={HERO_POSTER}
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        onLoadedData={handleVideoReady}
        onCanPlay={handleVideoReady}
      />
    </div>
  );
}

export default HeroVideo;
